import { render } from "./EditAjustesDest.vue?vue&type=template&id=45744b99&scoped=true"
import script from "./EditAjustesDest.vue?vue&type=script&lang=js"
export * from "./EditAjustesDest.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./EditAjustesDest.vue?vue&type=style&index=1&id=45744b99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45744b99"]])

export default __exports__